import {
  ChipField,
  FieldProps,
  ReferenceArrayField,
  SingleFieldList,
  useRecordContext,
  useTranslate,
} from 'react-admin';

const HardwareIdsField = ({ source = 'hardware_ids', ...props }: Partial<FieldProps>) => {
  const record = useRecordContext(props);
  const translate = useTranslate();
  const hardwareIds: number[] = record?.[source] || [];

  if (hardwareIds.length === 0) {
    return <>{translate('custom.labels.universal')}</>;
  }

  return (
    <ReferenceArrayField source={source} reference="hardware">
      <SingleFieldList linkType={false}>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

export default HardwareIdsField;
